import { FilterOption } from "@common/components/filterPopover/FilterPopover.types";
import { FilterPropertyKind, FilterPropertyMapping, mapFilterOptionsToRequest } from "@common/components/filterBar/filterRequestMapping";
import { ProcessingActivityRecordFilterData } from "./ProcessingActivityRecord.types";

export const groupEntityFilterId = "group-entity-ids";

type ProcessingActivityRecordFilterMapping = FilterPropertyMapping<keyof ProcessingActivityRecordFilterData>;

// The record endpoints take a single group company; the filter is single select, so the list never holds more than one.
const PROCESSING_ACTIVITY_RECORD_FILTERS: Record<string, ProcessingActivityRecordFilterMapping> = {
    [groupEntityFilterId]: { property: "groupEntityIds", kind: FilterPropertyKind.IdList },
    "show-only-mine": { property: "showOnlyMine", kind: FilterPropertyKind.Boolean },
    "processing-activity-ids": { property: "processingActivityIds", kind: FilterPropertyKind.IdList },
    "business-area-ids": { property: "businessAreaIds", kind: FilterPropertyKind.IdList },
};

// The record type and the sort are not filters in the bar, so they are carried over, and a changed filter starts on the
// first page again. A user who cannot access all data has no Show filter and only ever sees their own activities, which
// the backend default view says too.
export function transformProcessingActivityRecordFilterOptionsToBackend(
    filterOptions: Array<FilterOption>,
    current: Pick<ProcessingActivityRecordFilterData, "recordType" | "sortByColumn" | "sortDirection">,
    canAccessAllData: boolean
): ProcessingActivityRecordFilterData {
    const filterData = mapFilterOptionsToRequest<ProcessingActivityRecordFilterData>(filterOptions, PROCESSING_ACTIVITY_RECORD_FILTERS);

    return {
        ...filterData,
        recordType: current.recordType,
        showOnlyMine: canAccessAllData ? filterData.showOnlyMine : true,
        pageNumber: 1,
        sortByColumn: current.sortByColumn,
        sortDirection: current.sortDirection,
    };
}
